import { render, staticRenderFns } from "./PengajuanProfessional.vue?vue&type=template&id=a0685118&"
import script from "./PengajuanProfessional.vue?vue&type=script&lang=js&"
export * from "./PengajuanProfessional.vue?vue&type=script&lang=js&"
import style0 from "./PengajuanProfessional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports